export default "__VITE_ASSET__Efyj9InH__"